import { useEffect, useState } from "react";
import { courses } from "./data";
import {MdPreview } from 'react-icons/md'
import { Link } from "react-router-dom";

function Courses() {
    const [course, setCourse] = useState([])
    useEffect(() => { setCourse(courses) }, [])
    return (
        <>
            <div id="courses" className="section">

                <div className="container">

                    <div className="row">
                        <div className="section-header text-center">
                            <h2>Explore Courses</h2>
                            <hr className='title-hr'></hr>
                            {/* <p className="lead">Libris vivendo eloquentiam ex ius, nec id splendide abhorreant.</p> */}
                        </div>
                    </div>

                    <div id="courses-wrapper">

                        <div className="row">

                        <div className="col-md-3 col-sm-6 col-xs-6">
                                <div className="course">
                                    <Link to="/courses/react" className="course-img">
                                        <img src={require('../../../img/ReactJS.jpg')} alt=""></img>
                                        <i className="course-link-icon fa fa-link"></i>
                                        <strong className="course-title" >ReactJS Fullstack</strong>
                                        <div className="course-details">
                                            {/* <span className="course-category">Drawing</span> */}
                                            <span className="course-price course-premium">Go to Course</span>
                                        </div>
                                    </Link>
                                    
                                </div>
                            </div>

                            <div className="col-md-3 col-sm-6 col-xs-6">
                                <div className="course">
                                    <Link to="/courses/angular">
                                        <Link to="/courses/angular" className="course-img">
                                            <img src={require('../../../img/AngularJS.png')} alt=""></img>
                                            <i className="course-link-icon fa fa-link"></i>
                                            <strong className="course-title" >Angular Fullstack</strong>
                                            <div className="course-details">
                                                {/* <span className="course-category">Drawing</span> */}
                                                <span className="course-price course-premium">Go to Course</span>
                                            </div>
                                        </Link>
                                        
                                    </Link>
                                </div>
                            </div>

                            <div className="col-md-3 col-sm-6 col-xs-6">
                                <div className="course">
                                    <a href="#" className="course-img">
                                        <img  src={require('../../../img/python1.png')} alt=""></img>
                                        <i className="course-link-icon fa fa-link"></i>
                                    </a>
                                    <a className="course-title" href="#">Python Fullstack Course</a>
                                    <div className="course-details">
                                        <span className="course-category">.</span>
                                        <span className="course-price course-premium">Go to Course</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 col-sm-6 col-xs-6">
                                <div className="course">
                                    <a href="#" className="course-img">
                                        <img src={require('../../../img/fullstack.jpg')} alt=""></img>
                                        <i className="course-link-icon fa fa-link"></i>
                                    </a>
                                    <a className="course-title" href="#">Web Development Course </a>
                                    <div className="course-details">
                                        <span className="course-category">.</span>
                                        <span className="course-price course-premium">Go to Course</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">

                            <div className="col-md-3 col-sm-6 col-xs-6">
                                <div className="course">
                                    <a href="#" className="course-img">
                                        <img src={require('../../../img/dotnet.jpg')} alt=""></img>
                                        <i className="course-link-icon fa fa-link"></i>
                                    </a>
                                    <a className="course-title" href="#">DotNet Fullstack</a>
                                    <div className="course-details">
                                        <span className="course-category">.</span>
                                        <span className="course-price course-premium">Go to Course</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 col-sm-6 col-xs-6">
                                <div className="course">
                                    <a href="#" className="course-img">
                                        <img src={require('../../../img/testing.jpg')} alt=""></img>
                                        <i className="course-link-icon fa fa-link"></i>
                                    </a>
                                    <a className="course-title" href="#">Testing</a>
                                    <div className="course-details">
                                        <span className="course-category">.</span>
                                        <span className="course-price course-premium">Go to Course</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 col-sm-6 col-xs-6">
                                <div className="course">
                                    <a href="#" className="course-img">
                                        <img src={require('../../../img/database.jpg')} alt=""></img>
                                        <i className="course-link-icon fa fa-link"></i>
                                    </a>
                                    <a className="course-title" href="#">Database Management System</a>
                                    <div className="course-details">
                                        <span className="course-category">.</span>
                                        <span className="course-price course-premium">Go to Course</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 col-sm-6 col-xs-6">
                                <div className="course">
                                    <a href="#" className="course-img">
                                        <img src={require('../../../img/more.png')} alt=""></img>
                                        <i className="course-link-icon fa fa-link"></i>
                                    </a>
                                    <a className="course-title" href="#">More</a>
                                    <div className="course-details">
                                        <span className="course-category">.</span>
                                        <span className="course-price course-premium">Go to Course</span>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div className="row">
                        <div className="center-btn">
                            <a className="main-button icon-button" href="#">More Courses</a>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default Courses
